export const downloadOptions = [
    {
        label: "CSV",
        value: "csv"
    },
    {
        label: "Excel",
        value: "excel"
    }
]